import { render, staticRenderFns } from "./articleEdit.vue?vue&type=template&id=8cf119ce&scoped=true&"
import script from "./articleEdit.vue?vue&type=script&lang=js&"
export * from "./articleEdit.vue?vue&type=script&lang=js&"
import style0 from "./articleEdit.vue?vue&type=style&index=0&id=8cf119ce&prod&scoped=scoped&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cf119ce",
  null
  
)

export default component.exports